<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qjOla0/tc-custom/9781466833364.jpg?1737746740179" alt="This image is the cover for the book Lockstep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lockstep
      </h1>
      <p class="bookDescription body article font2">
        <b>Centuries of sleep bring a young space voyager into a strange future where he must confront his own tyrannical brother in this epic space opera.</b><br/><br/>When seventeen-year-old Toby McGonigal finds himself lost in space, his next drift into cold sleep to be his last. After all, the planet he’s orbiting is frozen and sunless, and dotted with dead cities. But when Toby wakes again, he’s surprised to discover a thriving planet, a strange and prosperous galaxy—and that he’s been asleep for 14,000 years.<br/><br/>Welcome to the Lockstep Empire, where civilization is kept alive by careful hibernation. Here cold sleeps can last decades and waking moments mere weeks. Its citizens survive for millennia, traveling asleep on long voyages between worlds. Not only is Lockstep the new center of the galaxy, but Toby is shocked to learn that the Empire is still ruled by its founding family: his own.<br/><br/>Toby’s brother Peter has become a tyrant. Suspicious of the return of his long-lost brother, whose rightful inheritance also controls the lockstep hibernation cycles, Peter sees Toby as a threat to his regime. Now, with the help of a lockstep girl named Corva, Toby must survive the forces of this new Empire, outwit his siblings, and save human civilization.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karl Schroeder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49306555